export default "__VITE_ASSET__BhOL3vGM__"